/**
 * UseCases.tsx — bruksområder i kolonner (ibm.com «Use cases»):
 * blått piktogram, tittel, tekst og tekstlenke med pil.
 */

import { ArrowRight } from '@carbon/icons-react';
import { LANDING_ICONS } from '@/components/landing/landing-icons';
import type { ProductUseCases } from '@/types/product';
import SectionHeader from './SectionHeader';
import styles from './product.module.css';

export default function UseCases({ useCases, id = 'bruk' }: { useCases: ProductUseCases; id?: string }) {
  return (
    <section id={id} className={styles.section} aria-labelledby="usecases-heading">
      <div className={styles.container}>
        <SectionHeader id="usecases-heading" eyebrow={useCases.eyebrow} heading={useCases.heading} />

        <ul className={styles.columns} role="list">
          {useCases.items.map((item) => {
            const Icon = LANDING_ICONS[item.icon];
            return (
              <li key={item.title} className={styles.column}>
                <Icon className={styles.pictogramBlue} aria-hidden />
                <h3 className={styles.h3}>{item.title}</h3>
                <p className={styles.columnText}>{item.body}</p>
                <a href={item.link.href} className={styles.textLink}>
                  {item.link.label}
                  <ArrowRight size={20} aria-hidden />
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
